<template>
	<v-container>
		<tutorial-popover
			step="0"
			:title="currentTutorialTitle()"
			:body="currentTutorialDescription()"
			@next-step="nextTutorialStep"
			@prev-step="prevTutorialStep"
			@abort="abortTutorial"
			:current="tutorialStep"
			:total="totalTutorialSteps()"
			v-slot="{ on, attrs }"
			top
			left
		>
			<v-form ref="form" v-model="valid">
				<v-row
					class="contentRow success"
					dense
					justify="space-between"
					v-if="id && !!isApproved"
				>
					<v-col class="">
						<h2 class="white--text">
							This template cannot be edited while it is approved
						</h2>
					</v-col>
					<v-col cols="2">
						<v-btn
							v-if="!!isApproved && canApprove"
							large
							color="orangeButton"
							elevation="0"
							class="float-right white--text"
							@click="approveTemplate"
							>Un-Approve This Template</v-btn
						>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="11">
						<v-row class="contentRow" dense v-bind="attrs" v-on="on">
							<v-col cols="4">
								<h1 class="text-left darkColor--text" v-if="name">
									Template: {{ name }}
								</h1>
								<h1 v-else>New Template</h1>
							</v-col>
							<v-spacer />
							<v-col class="flex-grow-0">
								<v-btn :disabled="!id" v-if="showContinueButton" @click="goBackToRequest" color="orangeButton" class="white--text">
									Continue Template Request
								</v-btn>
							</v-col>
							<v-col class="flex-grow-0">
								<tutorial-popover
									step="7"
									:title="currentTutorialTitle()"
									:body="currentTutorialDescription()"
									@next-step="nextTutorialStep"
									@prev-step="prevTutorialStep"
									@abort="abortTutorial"
									:current="tutorialStep"
									:total="totalTutorialSteps()"
									v-slot="{ on, attrs }"
								>
									<v-btn
										v-if="templateApprove"
										:disabled="!canApprove && !isApproved"
										:color="isApproved ? 'success' : 'primary'"
										class="float-right"
										:class="{
											'disable-events': isApproved || !canApprove
										}"
										elevation="0"
										@click="approveTemplateBtnClicked"
										v-on="on"
										v-bind="attrs"
										>{{ isApproved ? "Approved" : "Approve" }}</v-btn
									>
								</tutorial-popover>
							</v-col>

							<!-- <v-col class="flex-grow-0">
								<v-btn
									class="float-right"
									:color="allowFlowDown ? 'warning' : 'primary'"
									:disabled="!id"
									:outlined="!allowFlowDown"
									elevation="0"
									v-on:click="toggleFlowDown()"
								>
									{{allowFlowDown ? "Disable" : "Enable"}} Flow Down <v-icon right>fas fa-turn-down</v-icon>
								</v-btn>
							</v-col> -->
							<v-col class="flex-grow-0">
								<v-tooltip bottom>
									<template v-slot:activator="{on, attrs}">
										<v-btn
											v-on="on"
											v-bind="attrs"
											class="float-right"
											color="primary"
											:disabled="!id"
											outlined
											elevation="0"
											v-on:click="previewTemplate()"
										>
										<v-icon>fas fa-eye</v-icon>
										</v-btn>
									</template>
									<span >Show Preview</span>
								</v-tooltip>	
							</v-col>
							<v-col class="flex-grow-0">
								<v-tooltip bottom>
									<template v-slot:activator="{on, attrs}">
										<v-btn
											v-on="on"
											v-bind="attrs"
											:style="
												unsaved
													? 'border: 2pt outset black; border-color: var(--v-warning-base) !important; '
													: ''
											"
											class="float-right"
											:disabled="
												!valid || allQuestionsValid() !== true || isApproved
											"
											color="success"
											elevation="0"
											@click="saveOrNew.action"
										>
										<v-icon>fas fa-save</v-icon>
										</v-btn>
									</template>
									<span >Save</span>
								</v-tooltip>	
							</v-col>
							<v-col class="flex-grow-0">
								<tutorial-popover
									step="8"
									:title="currentTutorialTitle()"
									:body="currentTutorialDescription()"
									@next-step="nextTutorialStep"
									@prev-step="prevTutorialStep"
									@abort="abortTutorial"
									:current="tutorialStep"
									:total="totalTutorialSteps()"
									v-slot="tut"
								>
									<div>
										<v-menu offset-x left>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													class="float-right"
													color="white"
													ligth
													elevation="0"
													:disabled="!id"
													v-bind="{ ...attrs, ...tut.attrs }"
													v-on="{ ...on, ...tut.on }"
												>
													<v-icon>fas fa-ellipsis-v</v-icon>
												</v-btn>
											</template>
											<v-list>
												<v-list-item @click="dialogChangeHistory = true">
													<v-list-item-title>
														Change History
													</v-list-item-title>
												</v-list-item>
												<v-list-item @click="dialogApprovalHistory = true">
													<v-list-item-title>
														Approval History
													</v-list-item-title>
												</v-list-item>
												<v-list-item @click="tutorialStep = 0">
													<v-list-item-title>
														Tutorial Walkthrough
													</v-list-item-title>
												</v-list-item>
												<v-list-item
													:disabled="!valid || allQuestionsValid() !== true"
													@click="duplicateTemplateName()"
												>
													<v-list-item-title >
														Save As Duplicate
													</v-list-item-title>
												</v-list-item>
											</v-list>
										</v-menu>
									</div>
								</tutorial-popover>
							</v-col>
							<!--Template name-->
							<v-col cols="12">
								<tutorial-popover
									step="1"
									:title="currentTutorialTitle()"
									:body="currentTutorialDescription()"
									@next-step="nextTutorialStep"
									@prev-step="prevTutorialStep"
									@abort="abortTutorial"
									:current="tutorialStep"
									:total="totalTutorialSteps()"
									v-slot="{ on, attrs }"
								>
									<v-sheet rounded class="py-3 px-1">
										<v-text-field
											align="center"
											label="Template name"
											hide-details="auto"
											placeholder="Enter name here"
											outlined
											:rules="notEmptyRules"
											:value="name"
											@input="updateName({ name: $event })"
											:disabled="isApproved"
											v-on="on"
											v-bind="attrs"
										></v-text-field>
									</v-sheet>
								</tutorial-popover>
							</v-col>
							<!--Create Template Button-->
							<v-col cols="12" v-if="allQuestionsValid() !== true">
								<v-alert class="pointer-all" type="error" @click="goToError">
									{{ allQuestionsValid() }}
								</v-alert>
							</v-col>
							<v-col cols="12">
								<p>
									<i
										>Tip: You can re-order questions by dragging the grip
										handles:</i
									>
									<v-icon right class="handle">fas fa-grip-lines</v-icon>
								</p>
							</v-col>
							<v-col cols="12" v-if="flowDownFrom != null">
								<v-alert dense type="info">
									This audit template was created via Flow Down.
								</v-alert>
							</v-col>
							<v-spacer />
						</v-row>
						<div class="contentRow">
							<v-col style="border: 15px solid #1e7c83;">
								<v-col v-if="templateApprove" class="success"><h2 style="color: white">Your Template has been approved by the Auditor</h2></v-col>
								<v-col v-if="allComments.length > 0 && !templateApprove" class="orange"><h2 style="color: white">Pending Approval</h2></v-col>
								<h2 class="mb-3">Comments for Template from Auditor</h2>
								<div v-if="displayedComments.length > 0">
									<p style="font-size: 1rem" v-for="(comment, index) in displayedComments" :key="index">
										<v-icon small class="mr-1">fas fa-circle</v-icon> {{ comment.comment }}
									</p>
								</div>
								<div v-else>
									<p>No comment for this template.</p>
								</div>
								<v-btn :disabled="displayedComments.length === 0 || isLastCommentFixed" color="primary" @click="clickChecked()">Checked<v-icon right>fas fa-check</v-icon></v-btn>
							</v-col>
						</div>
						<draggable
							handle=".handle"
							v-model="draggableQuestions"
							group="people"
							@start="drag = true"
							@end="drag = false"
							@update="updateRows"
							:disabled="isApproved"
						>
							<div
								v-for="(question, index) in draggableQuestions"
								:key="index"
								class="mx-0"
							>
								<div v-if="index == 0"></div>
								<v-row
									align="center"
									class="contentRow py-1 mx-0 mb-2"
									dense
									v-else-if="question.type == 'spacer'"
								>
									<v-col cols="1">
										<v-tooltip bottom>
											<template v-slot:activator="{ on }">
												<v-icon v-on="on" class="handle"
													>fas fa-grip-lines</v-icon
												>
											</template>
											<span>Drag to Rearrange Question</span>
										</v-tooltip>
									</v-col>
									<v-col cols="1">
										<v-text-field
											autofocus
											:ref="'editQID' + index"
											v-if="editQuestionID == index"
											large
											class="centered-input"
											@blur="finishEditQID(index, $event)"
											@keyup.native.enter="enterFinishEditQID"
											:value="index"
											hide-details
											single-line
											type="number"
										/>
										<v-avatar
											@click="if (!isApproved) editQID(index)"
											v-else
											dense
											tile
											color="white"
											class="pointer"
										>
											<h3 class="darkColor--text" style="font-size: 1.75em;">
												{{ index }}
											</h3>
										</v-avatar>
									</v-col>
									<!--'Question Name' label-->
									<v-col cols="3">
										<h3>Spacer</h3>
									</v-col>
									<v-spacer />
									<!--'Remove' button-->
									<v-col cols="1">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													v-on="on"
													v-bind="attrs"
													outlined
													class="ml-2"
													color="darkColor"
													v-on:click="openDeleteDialog(index)"
													:disabled="isApproved"
												>
													<v-icon small>fas fa-times</v-icon>
												</v-btn>
											</template>
											<span>Remove Question</span>
										</v-tooltip>
									</v-col>
								</v-row>
								<tutorial-popover
									step="2"
									:title="currentTutorialTitle()"
									:body="currentTutorialDescription()"
									@next-step="nextTutorialStep"
									@prev-step="prevTutorialStep"
									@abort="abortTutorial"
									:current="currentTutorialStep()"
									:active="index == 1"
									:total="totalTutorialSteps()"
									v-slot="{ on, attrs }"
									v-else
									top
								>
									<v-row
										:id="`q${index}`"
										align="center"
										dense
										class="contentRow py-1 mb-4 mt-4"
										v-on="on"
										v-bind="attrs"
										@click.self="/*toggleVisible({ index })*/"
									>
										<v-col cols="1">
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-icon v-on="on" class="handle"
														>fas fa-grip-lines</v-icon
													>
												</template>
												<span>Drag to Rearrange Question</span>
											</v-tooltip>
										</v-col>
										<!--'Question Number' icon-->
										<v-col cols="1">
											<v-text-field
												autofocus
												:ref="'editQID' + index"
												v-if="editQuestionID == index"
												large
												class="centered-input"
												@blur="finishEditQID(index, $event)"
												@keyup.native.enter="enterFinishEditQID"
												:value="index"
												hide-details
												single-line
												type="number"
											/>
											<v-avatar
												@click="if (!isApproved) editQID(index)"
												v-else
												dense
												tile
												color="white"
												class="pointer"
											>
												<h3 class="darkColor--text" style="font-size: 1.75em;">
													{{ index }}
												</h3>
											</v-avatar>
										</v-col>
										<!--'Question Name' label-->
										<v-col
											cols="3"
											class="pointer-all"
											@click="toggleVisible({ index })"
										>
											<h3>{{ question.name }}</h3>
										</v-col>
										<v-spacer />
										<v-col>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<tutorial-popover
														step="3"
														:title="currentTutorialTitle()"
														:body="currentTutorialDescription()"
														@next-step="nextTutorialStep"
														@prev-step="prevTutorialStep"
														@abort="abortTutorial"
														:current="tutorialStep"
														:total="totalTutorialSteps()"
														:active="index == 1"
														top
														v-slot="{ on: on2, attrs: attrs2 }"
													>
														<v-sheet>
															<v-select
																:items="questionTypes"
																:value="getQuestionProperty(index, 'type')"
																@input="
																	updateQuestionProperty({
																		index: index,
																		prop: 'type',
																		value: $event
																	})
																"
																label="Outlined style"
																outlined
																dense
																class="centered-input"
																single-line
																hide-details
																:disabled="isApproved || question.flowDownLocked"
																v-on="{ ...on, ...on2 }"
																v-bind="{ ...attrs, ...attrs2 }"
															></v-select>
														</v-sheet>
													</tutorial-popover>
												</template>
												<span>Change question type</span>
											</v-tooltip>
										</v-col>
										<v-col cols="1">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														v-on="on"
														v-bind="attrs"
														outlined
														class="ml-2"
														color="darkColor"
														v-on:click="toggleVisible({ index })"
													>
														<v-icon small
															>fas fa-{{
																isQuestionVisible(index)
																	? "compress-alt"
																	: "expand-alt"
															}}</v-icon
														>
													</v-btn>
												</template>
												<span
													>{{
														isQuestionVisible(index) ? "Collapse " : "Expand "
													}}
													Question</span
												>
											</v-tooltip>
										</v-col>
										<!--'Remove' button-->
										<v-col cols="1">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														v-on="on"
														v-bind="attrs"
														outlined
														class="ml-2"
														color="darkColor"
														v-on:click="openDeleteDialog(index)"
														:disabled="isApproved || question.flowDownLocked"
													>
														<v-icon small>fas fa-times</v-icon>
													</v-btn>
												</template>
												<span>Remove Question</span>
											</v-tooltip>
										</v-col>
										<v-col cols="12" v-if="isQuestionVisible(index) && question.flowDownLocked">
											<v-alert type="info">This question is locked because of Flow Down from a previous audit.</v-alert>
										</v-col>
										<!--'Question Name' text field-->
										<v-col cols="12" v-if="isQuestionVisible(index)">
											<v-text-field
												class="mt-2"
												dense
												align="center"
												label="Question Name"
												hide-details="auto"
												placeholder="Enter Title here:"
												:rules="notEmptyRules"
												outlined
												:value="getQuestionProperty(index, 'name')"
												@input="
													updateQuestionProperty({
														index: index,
														prop: 'name',
														value: $event
													})
												"
												:disabled="isApproved || question.flowDownLocked"
											></v-text-field>
										</v-col>
										<!--'Question Details' text field-->
										<v-col cols="12" v-if="isQuestionVisible(index)">
											<v-textarea
												dense
												class="my-3"
												align="center"
												label="Details"
												hide-details="auto"
												placeholder="Enter details for question here:"
												outlined
												:value="getQuestionProperty(index, 'hint')"
												@input="
													updateQuestionProperty({
														index: index,
														prop: 'hint',
														value: $event
													})
												"
												:disabled="isApproved || question.flowDownLocked"
											></v-textarea>
										</v-col>
										<!--'Possibilities for multiple choice' select list-->
										<v-col
											cols="12"
											class="mt-3"
											v-if="
												(question.type == 'multiplechoice' ||
													question.type == 'multipleanswers') &&
													isQuestionVisible(index)
											"
										>
											<v-row
												align="center"
												class="my-2 mx-0"
												v-for="(possibility,
												pindex) in getPossibilitiesForQuestion(index)"
												:key="pindex"
											>
												<v-sheet outlined width="fit-content">
													<v-row align="center" class="mx-3">
														<v-checkbox
															v-if="question.type == 'multipleanswers'"
															:value="true"
															readonly
															class="left-input"
														>
														</v-checkbox>
														<v-radio
															v-if="question.type == 'multiplechoice'"
															off-icon="$radioOn"
															readonly
															class="left-input py-5"
														>
														</v-radio>
														<v-text-field
															autofocus
															:value="possibility"
															:disabled="isApproved || question.flowDownLocked"
															required
															dense
															class="left-input"
															height="20"
															hide-details
															single-line
															full-width
															append-icon="fas fa-times"
															@input="changePossibility(index, pindex, $event)"
															@click:append="removePossibility(index, pindex)"
															@keydown.enter="handleEnterKey(index)"
															placeholder="Enter option here:"
														></v-text-field>
													</v-row>
												</v-sheet>
												<v-responsive
													:aspect-ratio="1"
													max-width="50"
													v-if="
														pindex ==
															getPossibilitiesForQuestion(index).length - 1
													"
													class="ml-3"
												>
													<v-btn
														elevation="0"
														height="100%"
														x-small
														block
														tile
														color="success"
														class="white--text"
														:disabled="isApproved || question.flowDownLocked"
														@click="addPossibility(index)"
													>
														<v-icon>fas fa-plus</v-icon>
													</v-btn>
												</v-responsive>
											</v-row>
											<v-row align="center" class="my-2 mx-0">
												<v-btn
													v-if="getPossibilitiesForQuestion(index).length == 0"
													elevation="0"
													tile
													color="success"
													class="white--text"
													large
													:disabled="isApproved || question.flowDownLocked"
													@click="addPossibility(index)"
												>
													<v-icon left>fas fa-plus</v-icon>Add Answer
													Possibility
												</v-btn>
											</v-row>
										</v-col>
										<v-col
											cols="12"
											class="mt-3"
											v-else-if="
												question.type == 'attachment' &&
													isQuestionVisible(index)
											"
										>
											<p>
												<i
													>Anyone who fills out your audit template will be able
													to download the file you upload here.</i
												>
											</p>
											<file-uploader
												:value="getQuestionProperty(index, 'fileID')"
												@input="
													updateQuestionProperty({
														index: index,
														prop: 'fileID',
														value: $event
													})
												"
												:readonly="isApproved || question.flowDownLocked"
											/>
										</v-col>
										<!--'Dependency' check box-->
										<!-- <v-col cols="3" v-if="isQuestionVisible(index)">
											<v-checkbox
												class="mt-0"
												dense
												v-model="
													JSON.parse(JSON.stringify(questions))[index]
														.isDependent
												"
												@change="dependencyChanged(index, $event)"
												label="Display only if:"
												:disabled="isApproved || question.flowDownLocked"
											>
											</v-checkbox>
										</v-col> -->
										<!--'Dependency Question' text field-->
										<v-col cols="3" v-if="isQuestionVisible(index)">
											<v-select
												v-if="
													JSON.parse(JSON.stringify(questions))[index]
														.isDependent
												"
												dense
												outlined
												:value="
													getQuestionProperty(index, 'dependencyQuestionID')
												"
												@change="
													updateQuestionProperty({
														index: index,
														prop: 'dependencyQuestionID',
														value: $event
													})
												"
												:items="getPossibleDependencyQuestionForIndex(index)"
												menu-props="auto"
												label="Question #"
												hide-details="auto"
												prepend-icon="fas fa-question"
												single-line
												:disabled="
													!getQuestionProperty(index, 'isDependent') ||
														isApproved
												"
												:rules="dependencyIDRules(index)"
											></v-select>
										</v-col>
										<!--'Dependency Value' text field-->
										<v-col cols="5" offset="1" v-if="isQuestionVisible(index)">
											<v-combobox
												v-if="
													JSON.parse(JSON.stringify(questions))[index]
														.isDependent
												"
												:value="
													getQuestionProperty(index, 'dependencyQuestionValue')
												"
												@input="
													updateQuestionProperty({
														index: index,
														prop: 'dependencyQuestionValue',
														value: $event
													})
												"
												:items="
													getPossibilitiesForQuestion(
														getQuestionProperty(index, 'dependencyQuestionID')
													)
												"
												hide-selected
												label="Question Value"
												prepend-icon="fas fa-equals"
												multiple
												persistent-hint
												:disabled="
													!getQuestionProperty(index, 'isDependent') ||
														isApproved
												"
												:rules="dependencyValueRules(index)"
												deletable-chips
												chips
											>
												<template v-slot:no-data>
													<v-list-item>
														<v-list-item-content>
															<v-list-item-title>
																Press
																<kbd>enter</kbd> to enter a value
															</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
												</template>
											</v-combobox>
										</v-col>
										<!--'Dependency' check box-->
										<!-- <v-col cols="3" v-if="isQuestionVisible(index)">
											<v-checkbox
												class="mt-0"
												dense
												v-model="
													JSON.parse(JSON.stringify(questions))[index].required
												"
												@change="
													updateQuestionProperty({
														index: index,
														prop: 'required',
														value: !!$event
													})
												"
												:label="'Answer Required'"
												color="red"
												:disabled="isApproved || question.flowDownLocked"
											>
												<template v-slot:label>
													Required Question
													<sup
														><v-icon
															x-small
															:color="
																JSON.parse(JSON.stringify(questions))[index]
																	.required
																	? 'red'
																	: null
															"
															>fas fa-asterisk</v-icon
														></sup
													>
												</template>
											</v-checkbox>
										</v-col> -->
										<!-- Flow down toggle -->
										<!-- <v-col cols="12" v-if="isQuestionVisible(index) && allowFlowDown">
											<v-checkbox
												class="mt-0"
												dense
												v-model="
													JSON.parse(JSON.stringify(questions))[index].flowDown
												"
												@change="
													updateQuestionProperty({
														index: index,
														prop: 'flowDown',
														value: !!$event
													})
												"
												:label="'Flow Down required for this question'"
												color="blue"
												:disabled="isApproved || question.flowDownLocked"
											>
												<template v-slot:label>
													Flow Down required for this question
													<sup
														><v-icon
															small
															color="info"
															>fas fa-turn-down</v-icon
														></sup
													>
												</template>
											</v-checkbox>
										</v-col> -->
									</v-row>
								</tutorial-popover>
							</div>
						</draggable>

						<tutorial-popover
							step="5"
							:title="currentTutorialTitle()"
							:body="currentTutorialDescription()"
							@next-step="nextTutorialStep"
							@prev-step="prevTutorialStep"
							@abort="abortTutorial"
							:current="tutorialStep"
							:total="totalTutorialSteps()"
							v-slot="tut"
							top
						>
							<v-row
								class="px-0 my-0 contentRow transparent"
								dense
								justify="space-between"
								v-on="tut.on"
								v-bind="tut.attrs"
							>
								<v-menu offset-y top>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											block
											class="py-12 white--text"
											x-large
											style="text-transform: none; font-size: 1.8rem"
											color="orangeButton"
											elevation="0"
											light
											v-bind="attrs"
											v-on="on"
											:disabled="isApproved"
										>
											<v-icon left large class="mr-5"
												>fas fa-square-plus</v-icon
											>
											Add New Question
										</v-btn>
									</template>
									<v-list>
										<v-list-item
											@click="
												addMultipleChoiceQuestion({
													index: questions.length - 1
												})
											"
										>
											<v-list-item-title
												><v-icon left>fas fa-check-circle</v-icon>Multiple
												Choice</v-list-item-title
											>
										</v-list-item>
										<v-list-item
											@click="addQuestion({ index: questions.length - 1 })"
										>
											<v-list-item-title
												><v-icon left>fas fa-align-left</v-icon>Single
												Answer</v-list-item-title
											>
										</v-list-item>
										<v-list-item
											@click="
												addMultipleAnswersQuestion({
													index: questions.length - 1
												})
											"
										>
											<v-list-item-title
												><v-icon left>fas fa-check-square</v-icon>Multiple
												Answers</v-list-item-title
											>
										</v-list-item>
										<v-list-item
										@click="addFileQuestion({ index: questions.length - 1 })"
										>
											<v-list-item-title
												><v-icon left>fas fa-file-upload</v-icon>File
												Upload</v-list-item-title
											>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-row>
						</tutorial-popover>
						<!-- Checklist -->
						<div
							v-if="(getChecklist && getChecklist.length > 0) || showChecklist"
						>
							<v-row align="center" class="contentRow py-1 mx-0 mb-2" dense>
								<v-col cols="12">
									<h2 class="mt-5">
										Auditor Checklist
										<v-icon class="ml-4">far fa-check-square</v-icon>
									</h2>
								</v-col>
								<v-col cols="12">
									<p class="mt-5">
										<i
											>Tip: Create questions that the Auditor must answer when
											assessing the Audit</i
										>
									</p>
								</v-col>
								<v-col cols="12">
									<v-combobox
										@input="setChecklist({ value: $event })"
										:value="getChecklist"
										hide-selected
										label="Auditor Questions"
										multiple
										persistent-hint
										deletable-chips
										chips
										:disabled="isApproved"
									>
									</v-combobox>
								</v-col>
							</v-row>
						</div>

						<tutorial-popover
							step="6"
							:title="currentTutorialTitle()"
							:body="currentTutorialDescription()"
							@next-step="nextTutorialStep"
							@prev-step="prevTutorialStep"
							@abort="abortTutorial"
							:current="tutorialStep"
							:total="totalTutorialSteps()"
							v-slot="tut"
							top
							v-else
						>
							<v-row
								class="px-0 my-0 contentRow transparent"
								dense
								justify="space-between"
								@click="showChecklist = true"
								v-on="tut.on"
								v-bind="tut.attr"
							>
								<v-btn
									block
									class="py-12"
									x-large
									style="text-transform: none; font-size: 1.8rem"
									color="white"
									elevation="0"
									light
									:disabled="isApproved"
								>
									<v-icon left large class="mr-5">fas fa-square-plus</v-icon>
									Add Internal Checklist
								</v-btn>
							</v-row>
						</tutorial-popover>
					</v-col>
					<v-col cols="1" style="">
						<tutorial-popover
							step="4"
							:title="currentTutorialTitle()"
							:body="currentTutorialDescription()"
							@next-step="nextTutorialStep"
							@prev-step="prevTutorialStep"
							@abort="abortTutorial"
							:current="tutorialStep"
							:total="totalTutorialSteps()"
							v-slot="tut"
							left
						>
							<div style="position:relative">
								<v-row
									class="contentRow px-2"
									dense
									style="position: fixed;"
									:style="
										$vuetify.breakpoint.mdAndDown
											? 'max-width: 70px'
											: 'max-width: 90px'
									"
								>
									<v-col
										v-on="tut.on"
										v-bind="tut.attrs"
										class="flex-grow-0"
										lg="12"
									>
										<v-tooltip left>
											<template v-slot:activator="{ on: on2, attrs: attrs2 }">
												<v-menu offset-x left>
													<template v-slot:activator="{ on, attrs }">
														<v-responsive :aspect-ratio="1">
															<v-btn
																elevation="0"
																height="100%"
																x-small
																block
																color="orangeButton"
																class="white--text"
																v-bind="{ ...attrs, ...attrs2 }"
																v-on="{ ...on, ...on2 }"
																:disabled="isApproved"
															>
																<v-icon>fas fa-plus</v-icon>
															</v-btn>
														</v-responsive>
													</template>
													<v-list>
														<v-list-item @click="addMultipleChoiceQuestion">
															<v-list-item-title
																><v-icon left>fas fa-check-circle</v-icon
																>Multiple Choice</v-list-item-title
															>
														</v-list-item>
														<v-list-item @click="addQuestion">
															<v-list-item-title
																><v-icon left>fas fa-align-left</v-icon>Single
																Answer</v-list-item-title
															>
														</v-list-item>
														<v-list-item @click="addMultipleAnswersQuestion">
															<v-list-item-title
																><v-icon left>fas fa-check-square</v-icon
																>Multiple Answers</v-list-item-title
															>
														</v-list-item>
														<v-list-item @click="addFileQuestion({ index: questions.length - 1 })">
															<v-list-item-title
																><v-icon left>fas fa-file-upload</v-icon>File
																Upload</v-list-item-title
															>
														</v-list-item>
													</v-list>
												</v-menu>
											</template>
											<span>Add Question</span>
										</v-tooltip>
									</v-col>
									<v-col class="flex-grow-0" lg="12">
										<v-tooltip left>
											<template v-slot:activator="{ on, attrs }">
												<v-responsive :aspect-ratio="1" width="100%">
													<v-btn
														elevation="0"
														height="100%"
														x-small
														block
														outlined
														:disabled="isApproved"
														v-bind="attrs"
														v-on="on"
														@click="addTitle({ index: questions.length - 1 })"
													>
														<span style="font-size: 3em">T</span>
													</v-btn>
												</v-responsive>
											</template>
											<span>Add Title</span>
										</v-tooltip>
									</v-col>
									<v-col class="flex-grow-0" lg="12">
										<v-tooltip left>
											<template v-slot:activator="{ on, attrs }">
												<v-responsive :aspect-ratio="1">
													<v-btn
														elevation="0"
														height="100%"
														x-small
														block
														outlined
														v-bind="attrs"
														v-on="on"
														:disabled="isApproved"
														@click="addSpacer({ index: questions.length - 1 })"
													>
														<v-icon>fas fa-equals</v-icon>
													</v-btn>
												</v-responsive>
											</template>
											<span>Add Spacer</span>
										</v-tooltip>
									</v-col>
									<v-col class="flex-grow-0" lg="12">
										<v-tooltip left>
											<template v-slot:activator="{ on, attrs }">
												<v-responsive :aspect-ratio="1">
													<v-btn
														elevation="0"
														height="100%"
														x-small
														block
														outlined
														v-bind="attrs"
														v-on="on"
														:disabled="isApproved"
														@click="
															addAttachmentQuestion({
																index: questions.length - 1
															})
														"
													>
														<v-icon>far fa-file</v-icon>
													</v-btn>
												</v-responsive>
											</template>
											<span>Add Attachment</span>
										</v-tooltip>
									</v-col>
									<v-col cols="12">
										<v-divider light />
									</v-col>
									<v-col class="flex-grow-0" lg="12">
										<v-tooltip left>
											<template v-slot:activator="{ on, attrs }">
												<v-responsive :aspect-ratio="1">
													<v-btn
														elevation="0"
														height="100%"
														x-small
														block
														outlined
														v-bind="attrs"
														v-on="on"
														@click="
															updateQuestionVisible({
																visible: !anyQuestionsVisible
															})
														"
													>
														<v-icon class="font-weight-bold">
															fas fa-{{
																anyQuestionsVisible
																	? "compress-alt"
																	: "expand-alt"
															}}
														</v-icon>
													</v-btn>
												</v-responsive>
											</template>
											<span>{{
												anyQuestionsVisible
													? "Collapse Questions"
													: "Expand Questions"
											}}</span>
										</v-tooltip>
									</v-col>
									<v-col class="flex-grow-0" lg="12">
										<v-tooltip left>
											<template v-slot:activator="{ on, attrs }">
												<v-responsive :aspect-ratio="1" width="100%">
													<v-btn
														elevation="0"
														height="100%"
														x-small
														block
														v-bind="attrs"
														v-on="on"
														color="success"
														class="white--text"
														@click="saveOrNew.action"
														:style="
															unsaved
															? 'border: 2pt outset black; border-color: var(--v-warning-base) !important; '
															: ''
														"
														:disabled="
															!valid || allQuestionsValid() !== true || isApproved
														"
													>
														<v-icon>fas fa-save</v-icon>
													</v-btn>
												</v-responsive>
											</template>
											<span>Click to Save Template</span>
										</v-tooltip>
									</v-col>
								</v-row>
							</div>
						</tutorial-popover>
					</v-col>
				</v-row>
			</v-form>
		</tutorial-popover>
		<v-dialog v-model="duplicateTheTemplate" max-width="1000px" @click:outside="reloadPage">
			<v-card class="pl-7">
				<v-card-title class="primary--text">
					<span class="text-h4 pt-10">Template is duplicated as <b>{{ name }}</b> </span>
				</v-card-title>
				<v-card-title>
					<span class="text-h10  pb-4">Find your <b>saved Duplicated Templates</b> Under the <b>Not Approved templates</b> in the Template View.</span>
				</v-card-title>
				<v-card-actions class="mt-0 pb-5">
					<v-col class="text-left">
						<v-btn color="primary" class="ma-2 white--text" @click="viewDuplicateTemplate()">save and move to duplicated template</v-btn>
					</v-col>
					<v-col class="text-right">
						<v-btn color="primary" class="ma-2 white--text" @click="closeDialog">close</v-btn>
					</v-col>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogDelete" max-width="500px">
			<v-card>
				<v-card-title
					>Are you sure you want to remove question #{{
						deleteIndex
					}}?</v-card-title
				>
				<v-card-text
					>The information in this question will be lost!</v-card-text
				>
				<v-card-actions>
					<v-btn color="primary" text @click="dialogDelete = false"
						>Close</v-btn
					>
					<v-btn
						color="error"
						text
						@click="
							removeQuestion({ index: deleteIndex })
							dialogDelete = false
						"
						>Delete</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogPreview"
			max-width="1200px"
			height="auto"
			scrollable
			align="center"
		>
			<v-card>
				<v-card-text class="background-color: white">
					<template-preview v-if="id" :previewID="id" :preview="true" />
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" text @click="dialogPreview = false" outlined
						>Close</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogApprovalHistory" max-width="50%">
			<v-card class="pa-5">
				<v-card-actions>
					<v-spacer />
					<v-btn icon color="primary" @click="dialogApprovalHistory = false"
						><v-icon large>fas fa-times</v-icon></v-btn
					>
				</v-card-actions>
				<v-card-title
					style="font-size: 1.8rem !important; color:#227e85"
					class="justify-center pt-1 mb-6"
				>
					Audit Template Approval History
				</v-card-title>
				<v-card-text style="font-size: 1.2rem !important" class="text-center">
					<p v-for="(approval, index) in getApprovals" :key="index">
						<b>{{
							!!approval.firstname ? approval.firstname : approval.username
						}}</b>
						{{ approval.approval == 1 ? "" : "un" }}approved this template at
						{{ approval.timestamp | moment("DD/MM/YYYY HH:mm:ss") }}
					</p>
				</v-card-text>
				<v-card-text v-if="!isApproved" class="text-center">
					<p>This audit template is not approved yet.</p>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogChangeHistory" max-width="70%">
			<v-card class="pa-5">
				<v-card-actions>
					<v-spacer />
					<v-btn icon color="primary" @click="dialogChangeHistory = false"
						><v-icon large>fas fa-times</v-icon></v-btn
					>
				</v-card-actions>
				<v-card-title
					style="font-size: 1.8rem !important"
					class="justify-center pt-1 mb-6"
				>
					Audit Template Change History
				</v-card-title>
				<v-card-text style="font-size: 1.2rem !important" class="text-center">
					<p v-for="(change, index) in getChangelog" :key="index">
						<b>{{ !!change.firstname ? change.firstname : change.username }}</b>
						modified this template
						{{ change.timestamp | moment("DD/MM/YYYY HH:mm:ss") }}
					</p>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogApprove" max-width="70%">
			<v-card class="pa-5">
				<v-card-title
					style="font-size: 1.8rem !important"
					class="justify-center pt-1 mb-6"
				>
					Approve Template
				</v-card-title>
				<v-card-text style="font-size: 1.2rem !important" class="text-center">
					<p>When the template is approved, you will not be able to change it before it is un-approved.</p>
				</v-card-text>
				<v-card-actions class="justify-center">
					<v-btn outlined large color="primary" @click="dialogApprove = false"
						>Go back</v-btn
					>
					<v-btn
						color="success"
						large
						@click="
							approveTemplate()
							dialogApprove = false
						"
						>Approve</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <v-dialog v-if="templateCount === 0" v-model="selectAuditor" max-width="1000px" @click:outside="reloadPage">
			<v-card>
				<v-stepper v-model="step" class="elevation-0">
					<v-toolbar elevation="0" class="pr-0 mb-0">
						<v-col align="right" class="pr-1">
							<v-btn icon @click="selectAuditor = false">
								<v-icon large class="primary--text">fas fa-thin fa-times</v-icon>
							</v-btn>
						</v-col>
					</v-toolbar>
					<v-stepper-content step="1" class="pt-0">
						<v-card-title class="primary--text text-center justify-center">
							<span class="text-h4"><b>Choose Your Auditor</b></span>
						</v-card-title>
						<v-card-title class="text-center justify-center">
							<span class="text-h10">Select your Auditor from either <b>your Internal Team Members</b> or an <b>External Auditor</b>.</span>
						</v-card-title>
						<v-card-actions class=" justify-center">
							<v-btn color="secondary" @click="step = 2">Choose Internal Auditor</v-btn>
							<v-btn outlined color="secondary" @click="step = 3">Choose External Auditor</v-btn>
						</v-card-actions>
					</v-stepper-content>

					<v-stepper-content step="2" class="pt-0">
						<v-card-title class="primary--text">
							<span class="text-h5">Select Internal Auditor</span>
						</v-card-title>
						<v-card-text>
							<v-select
							:items="filteredTeamMembers"
							label="Team Members"
							v-model="selectedTeamMember"
							item-text="text"
							item-value="value"
							return-object
							>
								<template v-slot:prepend-item>
									<v-list-item>
										<v-list-item-content>
											<v-text-field 
											v-model="teamMemberSearch" 
											placeholder="Search Team Member" 
											autofocus
											append-icon="fa fa-close"
											@click:append="teamMemberSearch = ''"
											></v-text-field>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>
						</v-card-text>
						<v-card-actions>
							<v-btn color="primary" outlined @click="step = 1">
								<v-icon left>fas fa-arrow-left</v-icon> Previous
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="primary" :disabled="!selectedTeamMember" @click="selectInternalAuditor">
								Select <v-icon right>fas fa-check</v-icon>
							</v-btn>
						</v-card-actions>
					</v-stepper-content>

					<v-stepper-content step="3" class="pt-0">
						<v-card-title class="primary--text">
							<span class="text-h5">Select External Auditor</span>
						</v-card-title>
						<v-card-text class="text-center">
							<v-btn color="secondary" class="mx-2" @click="step = 4">Choose Existing External Auditor</v-btn>
							<v-btn outlined color="secondary" 
								class="mx-2" 
								@click="
									step = '5';
									$store.dispatch(
										'connections/invitationcodes/setInvitationCodeModalOpen',
										true
									);
								"
							><v-icon left>fas fa-plus</v-icon>Invite New Auditor</v-btn>
						</v-card-text>
						<v-card-actions>
							<v-btn color="primary" outlined @click="step = 1">
								<v-icon left>fas fa-arrow-left</v-icon> Previous
							</v-btn>
						</v-card-actions>
					</v-stepper-content>

					<v-stepper-content step="4" class="pt-0">
						<v-card-title class="primary--text">
							<span class="text-h5">Select External Auditor</span>
						</v-card-title>
						<v-card-text>
							<v-select
								:items="filteredConnections"
								label="Connections"
								v-model="selectedConnection"
								item-text="text"
								item-value="value"
								return-object
								>
								<template v-slot:prepend-item>
									<v-list-item>
										<v-list-item-content>
											<v-text-field 
											v-model="connectionSearch" 
											placeholder="Search Connection" 
											autofocus
											append-icon="fa fa-close"
											@click:append="connectionSearch = ''"
											></v-text-field>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>
						</v-card-text>
						<v-card-actions>
							<v-btn color="primary" outlined @click="step = 3">
								<v-icon left>fas fa-arrow-left</v-icon> Previous
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="primary" :disabled="!selectedConnection" @click="selectExternalAuditor">
								Select <v-icon right>fas fa-check</v-icon>
							</v-btn>
						</v-card-actions>
					</v-stepper-content>
					<v-stepper-content step="5" class="pt-0">
						<AddNewInvitationCode
								:isAuditRequestReceiver="true"
								@updateInvitationCode="updateInvitationCode"
							/>
						<NewCodeDisplay />
						<v-card-actions>
							<v-btn color="primary" outlined @click="step = 2">
								<v-icon left>fas fa-arrow-left</v-icon> Previous
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="primary" @click="step = 6">
								Send <v-icon right>fas fa-check</v-icon>
							</v-btn>
						</v-card-actions>
					</v-stepper-content>
					<v-stepper-content step="6" class="pt-0">
						<v-card class="elevation-0" style="border: 2px solid #227e85;" align="center">
							<v-card-title style="font-weight: bold; color: #227e85; margin-left: 44%;">Summary</v-card-title>
							<v-card-subtitle>
								Review the details of the template request below.
							</v-card-subtitle>
							<v-card-text class="text--primary">
								<p>Template: {{ name }}<b></b></p>
								<p v-if="selectedAuditor" >
									Will be sent to Auditor : '<b>{{ selectedAuditor }}</b>'
								</p>
								<p v-if="selectedInvitationCodes.length > 0">
									will be sent to invitation code : '<b>{{ selectedInvitationCodes[0] }}</b>
								</p>
							</v-card-text>
							<v-card-actions>
								<v-btn color="primary" outlined @click="step = 1">
									<v-icon left>fas fa-arrow-left</v-icon> Previous
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="sendTemplateRequest">
									Send <v-icon right>fas fa-check</v-icon>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-stepper-content>
				</v-stepper>
			</v-card>
		</v-dialog> -->
		<v-overlay :z-index="1" :value="this.tutorialStep >= 0"> </v-overlay>
	</v-container>
</template>

<script>
import TemplateAPI from "../api/audit/template"
import draggable from "vuedraggable"
import { mapGetters, mapActions, mapState } from "vuex"
import FilesAPI from "../api/files/files"
import LoadingState from "../consts/LoadingState"
import FileUploader from "./FileUploader.vue"
import OnsiteTemplatePreview from "../views/auditonsite/OnsiteTemplatePreview.vue"
import TutorialPopover from "./TutorialPopover.vue"
/* import ConnectionAPI from "../api/connections/connection"
import UsersAPI from "../api/connections/users" */
/* import AddNewInvitationCode from "../components/InvitationCodes/AddNewOnsite"
import NewCodeDisplay from "../components/InvitationCodes/NewCodeDisplay" */
export default {
	name: "TemplateEditor",
	props: {
		init_id: null
	},
	data() {
		return {
			templates: [],
			duplicateTheTemplate: false,
			sheet: false,
			notEmptyRules: [v => !!v || "This field cannot be empty"],
			valid: false,
			fileUpload: null,
			dialogDelete: false,
			deleteIndex: -1,
			saveClicked: false,
			errorQuestion: 0,
			savedQuestions: [],
			dialogPreview: false,
			editQuestionID: 0,
			dialogApprovalHistory: false,
			dialogChangeHistory: false,
			showChecklist: false,
			dialogApprove: false,
			dialogFlowDown: false,
			overlay: true,
			tutorialStep: -1,
			tutorialSteps: [
				[
					"Welcome to the Audit Template Builder",
					"We will now walk you through the basics of how to build your own template. If you want to exit the tutorial, click the 'X' at the top right of this window."
				],
				[
					"Change your audit template name",
					"Here you can change the name of your audit template. You can change it as many times as you like."
				],
				[
					"Create your first question",
					"Under 'question name' you can add your question. Then if you want you can add a description to the question."
				],
				[
					"Change question type",
					"If you want to change the type of question you are creating you can do it here by clicking on the dropdown field."
				],
				[
					"Add new question",
					"Here you can add new questions. When you click on the button you get to choose what type of question you want to use."
				],
				[
					"Or add a new question down here",
					"Here you can add new questions. When you click on the button you get to choose what type of question you want to use."
				],
				[
					"Internal checklist to review audit later on",
					"Here you can create an internal checklist that will be shown to your team and viewed when you assess the audit."
				],
				[
					"Approve the audit so that it can be sent to your suppliers",
					"When you have approved an audit template, it can not be edited. To edit you have to un-approve the template."
				],
				[
					"Tutorial Complete!",
					"You are finished! If you would like to go through the tutorial again, click the three dots, then 'Tutorial Walkthrough'."
				]
			],
			questionTypes: [
				{
					text: "Multiple Choice",
					value: "multiplechoice"
				},
				{
					text: "Single Answer",
					value: "singleanswer"
				},
				{
					text: "Multiple Answers",
					value: "multipleanswers"
				},
				{
					text: "File Upload",
					value: "file"
				}
			],
			lastSaveDate: 0,
			step: 1,
			selectAuditor: false,
			/* teamMembers: [],
			connections: [], */
			selectedTeamMember: null,
			selectedConnection: null,
			/* teamMemberSearch: "",
			connectionSearch: "", */
			selectedAuditor: null,
			selectedInvitationCodes: [],
			displayedComments: [],
			templateApprove: false,
			allComments: [],
			roleID: null,
			templateCount: 0,
			auditorType: null,
		}
	},
	mounted() {
		const templateID = this.$route.query.templateID

		if (templateID) {
			this.loadTemplate({ id: templateID }).then(() => {
				this.duplicateTemplateName()
			})
		} else if (this.init_id) {
			this.loadTemplate({ id: this.init_id })
			this.loadApprovalLog({ id: this.init_id })
			this.loadChangelog({ id: this.init_id })
		}
		/* this.loadConnections()
		this.loadTeamMembers() */
		this.getComments()
		
		if (this.$route.query.auditorType) {
			this.auditorType = parseInt(this.$route.query.auditorType)
		}
		if (this.$route.query.allowOnsite !== undefined) {
			this.$store.dispatch("audit/template/setAllowOnsite", { 
				allowOnsite: parseInt(this.$route.query.allowOnsite) 
			})

			if (parseInt(this.$route.query.allowOnsite) === 1 && (this.$route.query.auditor || this.$route.query.userName || this.$route.query.invitation)) {
				const query = {}
				if (this.$route.query.auditor) {
					query.auditor = this.$route.query.auditor
				}
				if (this.$route.query.userName) {
					query.userName = this.$route.query.userName
				}
				if (this.$route.query.auditorType) {
					query.auditorType = this.$route.query.auditorType
				}
				if (this.$route.query.invitation) {
					query.invitation = this.$route.query.invitation
				}
				
				this.$store.dispatch("audit/template/setTargetRoute", {
					route: {
						path: `/auditonsite/onsitetemplates/:id`, 
						query
					}
				})
			}
		}
	},
	methods: {
		...mapActions("audit/template", [
			"addMultipleAnswersQuestion",
			"addQuestion",
			"removeQuestion",
			"addTitle",
			"addFileQuestion",
			"addAttachmentQuestion",
			"addMultipleChoiceQuestion",
			"addSpacer",
			"updateQuestionProperty",
			"updateName",
			"updateFileID",
			"loadTemplate",
			"setQuestions",
			"saveTemplate",
			"addTemplate",
			"updateQuestionVisible",
			"toggleVisible",
			"setCorrectDepID",
			"approveTemplate",
			"setChecklist",
			"toggleLogVisible",
			"loadApprovalLog",
			"loadChangelog",
			"setAllowFlowDown",
			"setAllowOnsite"
		]),
		reloadPage() {
			location.reload()
		},
		closeDialog(){
			this.duplicateTheTemplate = false
			this.$router.push("/auditonsite/onsitedashboard")
		},
		goBackToRequest() {
			const templateID = this.$route.params.id
			const baseQuery = {
				templateID,
				templateName: this.name,
				step: "2b",
				auditorType: this.auditorType || this.$route.query.auditorType
			}
			if (this.$route.query.invitation) {
				baseQuery.invitation = this.$route.query.invitation
			} else if (this.$route.query.auditor && this.$route.query.userName) {
				baseQuery.auditor = this.$route.query.auditor
				baseQuery.userName = this.$route.query.userName
			}
			
			this.$router.push({ 
				path: "/auditonsite/onsitesender/newonsite", 
				query: baseQuery
			})
		},
		shouldReloadOnce() {
			const state = window.history.state || {}
			if (state && state.dupReloaded) return false
			const next = { ...state, dupReloaded: true }
			window.history.replaceState(next, document.title)
			return true
		},
		duplicateTemplateName() {
			TemplateAPI.onsiteList({ })
				.then(data => {
					this.templates = []
					for (let entry of data.items) {
						if (!entry.approval) {
							this.templates.push({
								templateID: entry.ID,
								name: entry.Name,
							})
						}
					}
					this.total = data.total
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.loading = false

					const currentTemplateName = this.name
					let duplicateIndex = 1

					let newTemplateName = `${currentTemplateName}(${duplicateIndex})`

					while (this.templates.some(template => template.name === newTemplateName)) {
						duplicateIndex++
						newTemplateName = `${currentTemplateName}(${duplicateIndex})`
					}

					this.updateName({ name: newTemplateName })
					/* this.duplicateTemplate	 */
					/* this.addTemplate().then(() => {
						this.duplicateTheTemplate = true
					}) */
					this.duplicateTheTemplate = true
					if (this.$route.path.includes("duplicate") && this.shouldReloadOnce()) {
						setTimeout(() => {
							window.location.reload()
						}, 300)
					}
				})
				
				.catch(error => {
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		viewDuplicateTemplate(){
			const originalQuestions = [...this.questions]
			const checklist = this.getChecklist
			TemplateAPI.addTemplate(this.name, originalQuestions, null, checklist, 0, 1)
				.then((id) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully created template with ID '${id}'`,
						{ root: true }
					)
					this.duplicateTheTemplate = false
					const query = {
						auditorType: this.auditorType || this.$route.query.auditorType
					}
					if (this.$route.query.auditor) {
						query.auditor = this.$route.query.auditor
						query.userName = this.$route.query.userName
					}else if (this.$route.query.invitation){
						query.invitation = this.$route.query.invitation
					}
					this.$router.push({
						path: `/auditonsite/onsitetemplates/${id}`,
						query
					}).then(() => {
						this.reloadPage()
					})
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		handleEnterKey(index){
			this.addPossibility(index)
		},
		saveNewTemplate() {
			this.saveClicked = true
		},
		changeClickedValue() {
			this.saveClicked = false
		},
		previewTemplate() {
			this.saveClicked = true
			if (this.allQuestionsValid() === true) {
				this.dialogPreview = true
			}
		},
		/* dependencyChanged(index, value) {
			this.updateQuestionProperty({
				index: index,
				prop: "isDependent",
				value: value
			})
			if (!value) {
				this.updateQuestionProperty({
					index: index,
					prop: "dependencyQuestionID",
					value: null
				})
				this.updateQuestionProperty({
					index: index,
					prop: "dependencyQuestionValue",
					value: null
				})
			}
			this.$refs.form.validate()
		}, */
		dependencyIDRules(index) {
			return [
				v =>
					!!v ||
					v == "0" ||
					!this.getQuestionProperty(index, "isDependent") ||
					"Dependency ID cannot be empty"
			]
		},
		dependencyValueRules(index) {
			return [
				v =>
					!!v ||
					v == "0" ||
					!this.getQuestionProperty(index, "isDependent") ||
					"Dependency Value cannot be empty"
			]
		},
		addAttachment(index) {
			FilesAPI.createFile(this.fileUpload.name, this.fileUpload)
				.then(file => {
					this.updateQuestionProperty({
						index: index,
						prop: "fileID",
						value: file.id
					})
					this.saveOrCreate()
				})
				.catch(err => {
					console.error(err)
				})
			this.fileUpload = null
		},
		removeAttachment(index) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{
					root: true
				}
			)
			let fileID = this.getQuestionProperty(index, "fileID")
			FilesAPI.deleteFile("" + fileID)
				.then(() => {
					this.updateQuestionProperty({
						index: index,
						prop: "fileID",
						value: null
					})
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"File successfully deleted!",
						{ root: true }
					)
				})
				.catch(reason => {
					console.error(reason)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		saveOrCreate() {
			if (!this.id) {
				if (!this.name) {
					this.updateName({ name: "Untitled Template" })
				}
				this.addTemplate()
			} else {
				this.saveTemplate()
			}
		},
		isQuestionVisible(index) {
			return this.draggableQuestions[index].visible
		},
		setQuestionVisible(index) {
			this.toggleVisible({ index })
			this.draggableQuestions = this.draggableQuestions.map(q => {
				return {
					...q
				}
			})
		},
		openDeleteDialog(index) {
			this.deleteIndex = index
			this.dialogDelete = true
		},
		goToError() {
			if (document.getElementById(this.errorQuestion)) {
				this.$vuetify.goTo("#" + this.errorQuestion)
			} else {
				this.$vuetify.goTo(0)
			}
		},
		allQuestionsValid() {
			if (this.saveClicked) {
				for (let i = 0; i < this.questions.length; i++) {
					let q = this.questions[i]
					if (q.type == "spacer") {
						return true
					}
					if (!q.name || q.name.length < 1) {
						this.errorQuestion = `q${i}`
						return `Question ${i}: Name cannot be empty.`
					}
					if (
						this.dependencyValueRules(i)[0](q.dependencyQuestionValue) !== true
					) {
						this.errorQuestion = `q${i}`
						return `Question ${i}: ${this.dependencyValueRules(i)[0](
							q.dependencyQuestionValue
						)}`
					}
					if (this.dependencyIDRules(i)[0](q.dependencyQuestionID) !== true) {
						this.errorQuestion = `q${i}`
						return `Question ${i}: ${this.dependencyIDRules(i)[0](
							q.dependencyQuestionID
						)}`
					}
				}
				if (!this.name) {
					this.errorQuestion = ``
					return "Template must have a name."
				}
				this.changeClickedValue()
				return true
			} else {
				return true
			}
		},
		updateRows(event) {
			this.setCorrectDepID({
				oldIndex: event.oldIndex,
				newIndex: event.newIndex
			})
		},
		changeVisibleLog(logType) {
			this.toggleLogVisible({ logType })
		},
		editQID(index) {
			this.editQuestionID = index
		},
		finishEditQID(index, event) {
			let newIndex = parseInt(event.target.value)
			this.editQuestionID = 0
			let error = this.validateNewIndex(newIndex)
			if (error != null) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					error,
					{ root: true }
				)
				return true
			}
			let questions = this.draggableQuestions
			let element = questions[index]
			questions.splice(index, 1)
			questions.splice(newIndex, 0, element)
			this.$set(this, "draggableQuestions", questions)

			this.setCorrectDepID({
				oldIndex: index,
				newIndex: newIndex
			})
			return true
		},
		enterFinishEditQID(event) {
			event.target.blur()
		},
		validateNewIndex(newIndex) {
			if (isNaN(parseInt(newIndex))) return "New question ID is not a number"
			if (newIndex < 1) return "New number must be 1 or higher."
			if (newIndex > this.questions.length - 1)
				return `New number is higher than the max (${this.questions.length -
					1})`
			return null
		},
		approveTemplateBtnClicked() {
			this.saveOrCreate()
			if (!this.isApproved) {
				this.dialogApprove = true
			}
		},
		currentTutorialStep() {
			return this.tutorialStep
		},
		totalTutorialSteps() {
			return this.tutorialSteps.length
		},
		currentTutorialPosition() {
			const left = this.$refs["tutorialstep0"]?.getBoundingClientRect().left
			const top = this.$refs["tutorialstep0"]?.getBoundingClientRect().bottom
			return [left ?? 0, top ?? 0]
		},
		currentTutorialDescription() {
			return this.tutorialSteps[this.currentTutorialStep()]?.[1]
		},
		currentTutorialTitle() {
			return this.tutorialSteps[this.currentTutorialStep()]?.[0]
		},
		nextTutorialStep() {
			if (this.tutorialStep == this.totalTutorialSteps() - 1) {
				return (this.tutorialStep = -1)
			}
			this.tutorialStep = this.tutorialStep + 1
		},
		prevTutorialStep() {
			if (this.tutorialStep == 0) {
				return
			}
			this.tutorialStep = this.tutorialStep - 1
		},
		abortTutorial() {
			this.tutorialStep = -1
		},
		addPossibility(index) {
			let current = (
				this.getQuestionProperty(index, "possibilities") ?? []
			).slice()
			current.push("")
			this.updateQuestionProperty({
				index: index,
				prop: "possibilities",
				value: current
			})
			this.saveOrCreate()
		},
		changePossibility(index, pindex, toValue) {
			let current = (
				this.getQuestionProperty(index, "possibilities") ?? []
			).slice()
			if (current.length - 1 < pindex) return
			current[pindex] = toValue
			this.updateQuestionProperty({
				index: index,
				prop: "possibilities",
				value: current
			})
		},
		removePossibility(index, pindex) {
			let current = (
				this.getQuestionProperty(index, "possibilities") ?? []
			).slice()
			if (current.length - 1 < pindex) return
			current.splice(pindex, 1)
			this.updateQuestionProperty({
				index: index,
				prop: "possibilities",
				value: current
			})
			this.saveOrCreate()
		},
		autoSave(fromTimeout) {
			if (!this.id) return
			if (!this.unsaved) return
			if (!this.valid) return
			this.saveClicked = true
			if (!this.allQuestionsValid()) return
			fromTimeout = fromTimeout || false
			if (Date.now() - this.lastSaveDate < 2000) {
				//ignore autosave more often than 3seconds
				console.log(
					`Tried to save too close to previous date. Diff was: ${+Date.now() -
						this.lastSaveDate}`
				)
				return
			}
			this.lastSaveDate = Date.now()
			this.saveTemplate().then(() => {
				if (fromTimeout) {
					return
				}
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
					"Auto-saving template...",
					{ root: true }
				)
				setTimeout(() => {
					this.autoSave(true)
				}, 3500)
			})
		},
		setFlowDown(value) {
			this.setAllowFlowDown({allowFlowDown: value})
		},
		toggleFlowDown() {
			if (this.allowFlowDown) {
				this.setFlowDown(false)
			} else {
				this.dialogFlowDown = true
			}
		},
		/* sendTemplateRequest(){
			this.selectAuditor = false
			const templateApproval = 0
			let auditorID = null

			if (this.selectedTeamMember) {
				auditorID = this.selectedTeamMember.value
			} 
			else if (this.selectedConnection) {
				auditorID = this.selectedConnection.value
			}

			const invitationCode = this.selectedInvitationCodes[0]

			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null,{ root: true })
			
			TemplateAPI.addTemplateRequest(this.id, templateApproval, auditorID, this.selectedAuditor, invitationCode)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully sent an onsite-audit template request`,
						{ root: true }
					)
					this.selectAuditor = false
					this.reloadPage()
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}, */
		getComments() {
			TemplateAPI.getTemplateComment(this.init_id)
				.then(result => {
					this.templateCount = result.length

					this.displayedComments = []
					this.allComments = []
					if (result && result.length > 0) {
						for (let entry of result) {
							if (entry.Comment) {
								try {
									const parsedComments = JSON.parse(entry.Comment)
									this.allComments = parsedComments || []
									if (entry.TemplateApproval === 0) {
										for (let comment of parsedComments) {
											if (comment.fixed === 0) {
												this.displayedComments.push(comment)
											}
										}
									}
								} catch (e) {
									console.error("Error parsing comments:", e)
									this.allComments = []
								}
							}
							if (entry.TemplateApproval === 1) {
								this.templateApprove = true
							}
						}
					}
				})
				
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		clickChecked(){
			const checked = true
			this.saveOrNew.action() // save the template
			this.selectAuditor = false
			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null,{ root: true })
			TemplateAPI.templateCommentChecked(this.id, checked)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully sent an onsite-audit template request`,
						{ root: true }
					)
					this.reloadPage()
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		/* loadConnections() {
			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, { root: true })
			
			ConnectionAPI.getOnsiteConnections()
				.then(data => {
					this.connections = []
					for (let entry of data) {
						this.connections.push({
							value: entry.clientID,
							text: `${entry.name}`,
							remove: null
						})
					}
					this.$store.dispatch("loading/" + LoadingState.ACTION_STOP_LOADING, null, { root: true })
				})
				.catch(error => {
					this.$store.dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, { root: true })
				})
		},
		loadTeamMembers() {
			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, { root: true })

			UsersAPI.getOnsiteUsers()
				.then(rawdata => {
					this.teamMembers = []
					for (let entry of rawdata) {
						this.teamMembers.push({
							text: entry.firstname ? `${entry.firstname}` : entry.username,
							value: entry.username
						})
					}
					this.$store.dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, { root: true })
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		}, */
		selectInternalAuditor() {
			if (this.selectedTeamMember) {
				this.selectedAuditor = this.selectedTeamMember.text
				this.step = 6
			}
		},
		
		selectExternalAuditor() {
			if (this.selectedConnection) {
				this.selectedAuditor = this.selectedConnection.text
				this.step = 6
			}
		},
		updateInvitationCode(updatedInvitationCode) {
			this.selectedInvitationCodes.push(updatedInvitationCode)
			if (updatedInvitationCode) {
				this.selectedAuditor
			}
		},
	},
	computed: {
		...mapGetters("audit/template", [
			"getPossibilitiesForQuestion",
			"getPossibleDependencyQuestionForIndex",
			"getTemplateDataForSubmit",
			"getQuestionProperty",
			"anyQuestionsVisible",
			"unsaved",
			"isApproved",
			"getChecklist",
			"getApprovals",
			"getApprovalsVisible",
			"getChangelog",
			"getChangelogVisible"
		]),
		...mapState("audit/template", {
			questions: state => state.questions,
			name: state => state.name,
			id: state => state.id,
			fileID: state => state.fileID,
			approval: state => state.approval,
			approvedBy: state => state.approvedBy,
			approvedTimestamp: state => state.approvedTimestamp,
			lastChangedTimestamp: state => state.lastChangedTimestamp,
			lastChangedBy: state => state.lastChangedBy,
			allowFlowDown: state => state.allowFlowDown,
			flowDownFrom: state => state.flowDownFrom,
			allowOnsite: state => state.allowOnsite,
		}),
		draggableQuestions: {
			get() {
				return [...this.questions]
			},
			set(q) {
				this.setQuestions({ questions: q })
			}
		},
		showContinueButton() {
			return Boolean(this.$route.query.invitation || (this.$route.query.auditor && this.$route.query.userName))
		},
		saveOrNew() {
			return {
				icon: "fas fa-" + (!this.id ? "plus" : "save"),
				color: "success",
				action: async () => {
					this.selectAuditor = true
					this.saveClicked = true
					if (this.allQuestionsValid() !== true) {
						this.$vuetify.goTo(0)
						return
					}
					if (!this.id) {
						await this.addTemplate()
					} else {
						await this.saveTemplate()
					}
					this.$nextTick(() => {
						this.$vuetify.goTo(0)
					})
				}
			}
		},
		canApprove() {
			return this.$accessToOperation("ATA", "U")
		},
		/* filteredConnections() {
			if (!this.connectionSearch) {
				return this.connections
			}
			return this.connections.filter((connection) => {
				return connection.text.toLowerCase().indexOf(this.connectionSearch.toLowerCase()) > -1
			})
		},
		filteredTeamMembers() {
			if (!this.teamMemberSearch) {
				return this.teamMembers
			}
			
			return this.teamMembers.filter((member) => {
				return member.text.toLowerCase().indexOf(this.teamMemberSearch.toLowerCase()) > -1
			})
		}, */
		isLastCommentFixed() {
			const last = this.displayedComments[this.displayedComments.length - 1]
			return last && last.fixed === 1
		}
	},
	components: {
		draggable,
		"file-uploader": FileUploader,
		"template-preview": OnsiteTemplatePreview,
		"tutorial-popover": TutorialPopover,
		/* AddNewInvitationCode,
		NewCodeDisplay, */
	},
	watch: {
		draggableQuestions: {
			handler() {
				//this.autoSave()
				//Disabled autosave for now, will perhaps enable in future, if validation is fixed.
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.handle {
	cursor: grab;
}
div > .pointer {
	cursor: pointer;
}
.pointer > div {
	cursor: auto;
}
.pointer-all {
	cursor: pointer !important;
}
h3 {
	font-weight: 500;
}
.centered-input >>> input {
	text-align: center;
	font-size: 1.2em;
	height: 100%;
}
.left-input >>> input {
	text-align: left;
	font-size: 1.2em;
	height: 100%;
}
.disable-events {
	pointer-events: none;
}
.tutorialElement {
	position: relative;
	z-index: 999;
}
p {
	font-size: 14px;
}
</style>
